import { animate, finish, isAnimating, stop, timeSpent } from "liquid-fire"

export default function fade(dimension, direction, opts, offset = 10) {
  // const oldParams = { opacity: 0, scaleX: "0.92", scaleY: "0.92" },
  //       newParams = { opacity: [[(opts.maxOpacity || 1), 0], "linear"], scaleX: [["1", "0.92"], [500, 30]], scaleY: [["1", "0.92"], [400, 15]]},
  //       fadingElement = findFadingElement(this);
  const oldParams = { opacity: 0, scaleX: 0.8, scaleY: 0.8 },
    // newParams = { scaleX: [1, [400, 20], 0.85], scaleY: [1, [400, 20], .85]},
    // newParams = { scaleX: [1, "easeOutExpo", 0.80], scaleY: [1, "easeOutExpo", .50], opacity: [1, "easeOutCubic", .85]},
    newParams = {
      scaleX: [1, [0.175, 0.885, 0.32, 1.275], 0.8],
      scaleY: [1, [0.175, 0.885, 0.32, 1.275], 0.8],
      opacity: [1, "easeOutCubic", 0.85],
    },
    fadingElement = findFadingElement(this)

  let outOpts = opts,
    firstStep

  // if (dimension.toLowerCase() === 'x') {
  //   oldParams.translateX = `${(direction * offset)}px`;
  //   newParams.translateX = ['0px', `${(direction * offset)}px`];
  // } else {
  //   oldParams.translateY = `${(direction * offset)}px`;
  //   newParams.translateY = ['0px', `${(direction * offset)}px`];
  // }

  if (fadingElement) {
    // We still have some older version that is in the process of
    // fading out, so out first step is waiting for it to finish.
    firstStep = finish(fadingElement, "fade-out")
  } else {
    if (isAnimating(this.oldElement, "fade-in")) {
      // if the previous view is partially faded in, scale its
      // fade-out duration appropriately.
      outOpts = { duration: timeSpent(this.oldElement, "fade-in") }
    }
    stop(this.oldElement)
    firstStep = animate(this.oldElement, oldParams, outOpts, "fade-out")
  }
  return firstStep.then(() => {
    return animate(this.newElement, newParams, opts, "fade-in")
  })
}

function findFadingElement(context) {
  for (var i = 0; i < context.older.length; i++) {
    var entry = context.older[i]
    if (isAnimating(entry.element, "fade-out")) {
      return entry.element
    }
  }
  if (isAnimating(context.oldElement, "fade-out")) {
    return context.oldElement
  }
}
